import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { IconButton } from '@mui/material';

interface StatsPanelHeaderProps {
  title: string;
  isExpanded: boolean;
  onToggle: () => void;
}

export const StatsPanelHeader = ({
  title,
  isExpanded,
  onToggle,
}: StatsPanelHeaderProps) => {
  return (
    <div className='flex items-center gap-2'>
      <h2 className='text-xl !font-bold text-gray-800 ml-1'>{title}</h2>

      <div className='group relative flex items-center ml-1'>
        <InfoOutlinedIcon className='text-slate-400 cursor-help hover:text-blue-500 transition-colors !w-5 !h-5' />
        <div className='absolute left-full top-1/2 -translate-y-1/2 ml-3 w-64 p-3 bg-slate-800 text-white text-xs rounded-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 shadow-xl pointer-events-none'>
          <div className='absolute left-0 top-1/2 -translate-x-[5px] -translate-y-1/2 w-3 h-3 bg-slate-800 rotate-45 transform'></div>
          <p className='relative z-10 leading-relaxed font-medium'>
            El promedio de minutos se cuenta desde que la persona se registra en
            el tótem hasta que finaliza su atención y se retira.
          </p>
        </div>
      </div>

      <IconButton
        onClick={onToggle}
        size='small'
        sx={{
          transition: 'transform 0.2s',
          transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
          backgroundColor: 'rgba(0,0,0,0.03)',
          '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.06)',
          },
        }}
      >
        <ExpandMoreIcon />
      </IconButton>
    </div>
  );
};
